import { Box, Divider, Typography, Stack } from "@mui/material"
import SufferedAnInjury from "components/shared/fields/check/SufferedAnInjury"
import HighCholesterol from "components/shared/fields/check/HighCholesterol"
import Hypertension from "components/shared/fields/check/Hypertension"
import Diabets from "components/shared/fields/check/Diabets"
import SecondaryButton from "components/shared/buttons/SecondaryButton"
import GrayButton from "components/shared/buttons/GrayButton"
import useAppStore from "store/app"
import useTranslation from "hooks/use_translation"

const CommonQuestions = () => {
  const fields = useAppStore((state) => state.fields)
  const { direction } = useAppStore((state) => state.meta)
  const nextAnamnesisStep = useAppStore((state) => state.nextAnamnesisStep)
  const prevAnamnesisStep = useAppStore((state) => state.prevAnamnesisStep)

  const updateAnamnesis = useAppStore((state) => state.updateAnamnesis)
  const updateFieldErrorMessage = useAppStore((state) => state.updateFieldErrorMessage)
  const { anamnesis } = useTranslation()

  const diagnosticToBoolean = (value) => value === "yes"

  const handleSubmit = (event) => {
    event.preventDefault()

    const errorsCheck = ["cholesterol", "hypertension", "injury", "diabetes"]

    let initialValid = true

    errorsCheck.map((field) => {
      if (!fields[field]?.touched) {
        updateFieldErrorMessage(field, "This field is required")
        initialValid = false
      }
    })

    if (!initialValid) return

    const valid = errorsCheck.every((field) => fields[field].error_message === "")

    if (!valid) return

    const params = {
      cholesterol: diagnosticToBoolean(fields.cholesterol?.input_value),
      hypertension: diagnosticToBoolean(fields.hypertension?.input_value),
      injury: diagnosticToBoolean(fields.injury?.input_value),
      diabetes: diagnosticToBoolean(fields.diabetes?.input_value),
    }

    updateAnamnesis(params).then(() => nextAnamnesisStep())
  }

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 3 }}>
        {anamnesis?.common_questions}
      </Typography>
      <SufferedAnInjury />
      <Divider sx={{ my: 3 }} />
      <HighCholesterol />
      <Divider sx={{ my: 3 }} />
      <Hypertension />
      <Divider sx={{ my: 3 }} />
      <Diabets />

      <Stack direction={direction === "rtl" ? "row-reverse" : "row"} columnGap={3}>
        <GrayButton text={anamnesis?.back_btn} fullWidth onClick={prevAnamnesisStep} />

        <SecondaryButton text={anamnesis?.next_btn} type="submit" fullWidth />
      </Stack>
    </Box>
  )
}

export default CommonQuestions
